<template>
  <el-dialog
    title="Сформировать отчет по Хартии"
    append-to-body
    :visible="visible"
    :width="isMobile ? '95%' : '60%'"
    @close="() => $emit('close')"
  >
    <el-form label-position="top" :inline="true">
      <el-form-item label="Начало периода:">
        <el-date-picker
          v-model="formData.dateFrom"
          placeholder="Начало периода"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="Окочание периода:">
        <el-date-picker
          v-model="formData.dateTo"
          type="date"
          placeholder="Окочание период"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item class="el-form-item--hartia_submit">
        <el-button
          plain
          type="primary"
          :icon="loading ? 'el-icon-loading' : ''"
          :disabled="loading"
          @click="submitForm()"
        >
          Сформировать документ
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { SEND_FORM } from '@/store/actions/reportForwarder'

export default {
  name: 'DialogReportHartia',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        dateFrom: '',
        dataTo: '',
      },
      loading: false,
    }
  },
  methods: {
    submitForm() {
      this.loading = true

      if (
        this.formData.dateFrom &&
        this.formData.dateTo &&
        this.formData.dateFrom > this.formData.dateTo
      ) {
        this.$message.error(
          'Конечная дата не должна быть раньше начальной даты периода',
        )
      } else {
        const data = {
          dateFrom: this.formData.dateFrom,
          dateTo: this.formData.dateTo,
        }

        this.$store
          .dispatch(`reportForwarder/${SEND_FORM}`, data)
          .then(response => {
            const dateFrom = this.getFormattedMomentDate(this.formData.dateFrom)
            const dateTo = this.getFormattedMomentDate(this.formData.dateTo)

            this.forceFileDownload(response, `отчет_${dateFrom}_${dateTo}.xls`)
            this.$message.success('Файл сформировался, началось скачивание')
          })
          .catch(e => this.$message.error(e))
          .finally(() => (this.loading = false))
      }
    },
    getFormattedMomentDate(date) {
      return this.dateToFormat(date, 'defaultDate')
    },
  },
}
</script>

<style lang="sass">
.el-form-item--hartia_submit
  display: block !important
.el-form--inline .el-form-item__label
  font-family: "Rubik", sans-serif
</style>
